import React from 'react'
import styled from 'styled-components'
import Query from './Query'
import Layout from '../Layout'
import Hero, { HeroTitle } from '../Hero'
import Navigation from './Navigation'
import Video from '../Video'
import Markdown from '../Markdown'
import FullWidthSection from '../FullWidthSection'
import Link from '../Link'
import UploadCarePicture from '../UploadCarePicture'

const Content = styled.div`
  margin: 6rem 0;
`

const MainVideo = styled.div`
  width: 100%;
  max-width: 70rem;
  display: block;
  margin: 0 auto 8rem;
`

const BodyText = styled.div`
  margin: 2rem auto;
  max-width: 70rem;
  display: block;
  text-align: center;
`

const PartnersContainer = styled.div`
  margin-top: 8rem;
  background-color: ${({ theme }) => theme.colors.primaryHighlight};
`

const PartnersInner = styled.div`
  width: 100%;
  max-width: ${({ theme }) => theme.dimensions.contentWidth};
  padding: 0 ${({ theme }) => theme.dimensions.contentGutterSize};
  text-align: center;
`

const PartnersTitle = styled.h2`
  text-align: center;
  display: block;
  margin: 0;
  padding: 4rem 0 2rem;
`

const Partner = styled.div`
  display: inline-block;
  padding: 0 2rem 4rem;
  max-width: 30rem;
  vertical-align: middle;

  img {
    margin: 0;
  }
`

export default () => (
  <Query
    render={(content) => (
      <Layout>
        <Hero>
          <HeroTitle useH1>{content.title}</HeroTitle>
        </Hero>
        <Navigation />
        <Content>
          <MainVideo>
            <Video id={content.about_page.main_video_id} />
          </MainVideo>
          <BodyText>
            <Markdown source={content.about_page.body_text} />
          </BodyText>
          <FullWidthSection>
            <PartnersContainer>
              <PartnersInner>
                <PartnersTitle>
                  {content.about_page.education_partners_title}
                </PartnersTitle>
                {content.about_page.education_partners.map((partner) => (
                  <Partner key={partner.link}>
                    <Link
                      tracking={{
                        label: `education_about_partner_${partner.link}`
                      }}
                      href={partner.link}
                      title={partner.name}
                    >
                      <UploadCarePicture
                        src={partner.thumbnail}
                        size={300}
                        alt={partner.name}
                      />
                    </Link>
                  </Partner>
                ))}
              </PartnersInner>
            </PartnersContainer>
          </FullWidthSection>
        </Content>
      </Layout>
    )}
  />
)
